import keyMirror from 'key-mirror';
export default keyMirror({
  /* Nav */
  SET_HEADER_COLOR: null,
  SET_HEADER_BACKGROUND: null,

  /* User */
  GET_USER_ROLE: null,
  SAVE_USER_ROLE: null,
  UPDATING_USER: null,
  CLEAR_USER_ROLE: null,
  ERROR_UPDATING_USER: null,
  SELECT_PREMIUM_PRODUCT: null,

  /* Legend dropdown */
  TOGGLE_ITEMS: null,

  /* Legend checkbox */
  TOGGLE_CHECKBOX: null,
  UNCHECK_CHECKBOX: null,

  /* Shopping Cart */
  ADD_TO_CART: null,
  REMOVE_FROM_CART: null,

  /* Logics */
  LOGIC: null,

  /* Data */
  GET_DATA: null,
  SAVE_COUNTRY_DATA: null,

  /* Plot */
  SAVE_PLOT_DATA: null,
  SET_CURRENT_DATA: null,
  TOGGLE_LOAD_PLOT_DATA: null,
  SAVE_PLOT_META_DATA: null,
  UPDATE_PLOT_DATA_RANGE: null,
  SET_CURRENT_DATE_RANGE: null,
  SET_TOTAL_DATE_RANGE: null,
  ADD_ENTRY: null,
  UPDATE_DATE_RANGE: null
});